import { render, staticRenderFns } from "./EditSurveyQuestions.vue?vue&type=template&id=a48d9d6c&scoped=true&"
import script from "./EditSurveyQuestions.vue?vue&type=script&lang=js&"
export * from "./EditSurveyQuestions.vue?vue&type=script&lang=js&"
import style0 from "./EditSurveyQuestions.vue?vue&type=style&index=0&id=a48d9d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48d9d6c",
  null
  
)

component.options.__file = "EditSurveyQuestions.vue"
export default component.exports